import { render, staticRenderFns } from "./landing-page-hero.vue?vue&type=template&id=712952d4&scoped=true&lang=pug"
import script from "./landing-page-hero.js?vue&type=script&lang=js&external"
export * from "./landing-page-hero.js?vue&type=script&lang=js&external"
import style0 from "./landing-page-hero.vue?vue&type=style&index=0&id=712952d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712952d4",
  null
  
)

export default component.exports